module.exports = __webpack_public_path__ + "img/btnincell-m.925639dc.svg";